import $ from 'jquery';
import 'slick-carousel';


$('.component-photo-gallery-control').slick({
    // infinite: true,
    dots: false,
    speed: 200,
    accessibility: true,
    autoplay: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    asNavFor: '.component-photo-gallery-main',
    centerMode: true,
    focusOnSelect: true
});

$('.component-photo-gallery-main').slick({
    // infinite: true,
    dots: false,
    speed: 200,
    accessibility: true,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.component-photo-gallery-control',
    adaptiveHeight: true
});